(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khascart-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('khascart-story-categories')) {
    customElements.define(
      'khascart-story-categories',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal:this.controller.signal };

          this.scroller = this.querySelector('.ksc-scroller');
          this.list = this.querySelector('.ksc-list');
          this.button = this.querySelector('[data-pause]');
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.enabled = this.dataset.autoplay === 'true';
          this.paused = false;
          this.hovering = false;
          this.touching = false;
          this.editing = false;
          this.direction = 1;
          this.position = this.scroller.scrollLeft;
          this.speed = Number(this.dataset.speed) || 24;
          this.resumeAt = 0;
          this.lastTime = null;

          if (this.button) {
            this.button.hidden = false;
            this.button.addEventListener('click', () => {
              this.paused = !this.paused;
              this.button.setAttribute(
                'aria-label',
                this.paused
                  ? 'Resume category scrolling'
                  : 'Pause category scrolling'
              );
              this.button.querySelector('[data-icon]').setAttribute(
                'd',
                this.paused ? 'M9 5l10 7-10 7Z' : 'M9 5v14M15 5v14'
              );
            }, options);
          }

          this.scroller.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') this.hovering = true;
          }, options);

          this.scroller.addEventListener('pointerleave', () => {
            this.hovering = false;
            this.position = this.scroller.scrollLeft;
          }, options);

          this.scroller.addEventListener('pointerdown', () => {
            this.touching = true;
            this.lastTime = null;
          }, options);

          const release = () => {
            if (!this.touching) return;
            this.touching = false;
            this.resumeAt = performance.now() + 1800;
            this.position = this.scroller.scrollLeft;
          };

          window.addEventListener('pointerup', release, options);
          window.addEventListener('pointercancel', release, options);

          this.scroller.addEventListener('wheel', () => {
            this.resumeAt = performance.now() + 1800;
          }, { ...options, passive:true });

          this.scroller.addEventListener('scroll', () => {
            if (this.touching || performance.now() < this.resumeAt) {
              this.position = this.scroller.scrollLeft;
            }
          }, { ...options, passive:true });

          document.addEventListener('shopify:block:select', event => {
            if (!this.contains(event.target)) return;
            this.editing = true;
            const item = event.target.closest('.ksc-item');
            if (item) {
              const delta = item.getBoundingClientRect().left -
                this.scroller.getBoundingClientRect().left;
              this.scroller.scrollLeft += delta;
            }
          }, options);

          document.addEventListener('shopify:block:deselect', event => {
            if (!this.contains(event.target)) return;
            this.editing = false;
            this.position = this.scroller.scrollLeft;
          }, options);

          this.tick = time => {
            if (!this.isConnected) return;

            const elapsed = this.lastTime === null
              ? 0
              : Math.min((time - this.lastTime) / 1000, .05);

            this.lastTime = time;

            const max = Math.max(
              0,
              this.scroller.scrollWidth - this.scroller.clientWidth
            );

            const blocked =
              !this.enabled ||
              this.paused ||
              this.motion.matches ||
              this.hovering ||
              this.touching ||
              this.editing ||
              document.hidden ||
              this.contains(document.activeElement) ||
              time < this.resumeAt ||
              max <= 1;

            if (blocked) {
              this.position = this.scroller.scrollLeft;
            } else {
              this.position += this.direction * this.speed * elapsed;

              if (this.position >= max) {
                this.position = max;
                this.direction = -1;
              } else if (this.position <= 0) {
                this.position = 0;
                this.direction = 1;
              }

              this.scroller.scrollLeft = this.position;
            }

            this.frame = requestAnimationFrame(this.tick);
          };

          this.frame = requestAnimationFrame(this.tick);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khascart-category-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('khascart-category-switcher')) {
    customElements.define(
      'khascart-category-switcher',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal:this.controller.signal };

          this.tabs = [...this.querySelectorAll('[data-tab]')];
          this.panels = [...this.querySelectorAll('[data-panel]')];
          this.storageKey = 'khascart-saved-products-v1';

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              this.activate(tab.dataset.tab);
            }, options);

            tab.addEventListener('keydown', event => {
              let target = index;

              if (event.key === 'ArrowRight') {
                target = (index + 1) % this.tabs.length;
              } else if (event.key === 'ArrowLeft') {
                target = (index - 1 + this.tabs.length) % this.tabs.length;
              } else if (event.key === 'Home') {
                target = 0;
              } else if (event.key === 'End') {
                target = this.tabs.length - 1;
              } else {
                return;
              }

              event.preventDefault();
              const next = this.tabs[target];
              this.activate(next.dataset.tab);
              next.focus({ preventScroll:true });
              next.scrollIntoView({
                block:'nearest',
                inline:'nearest',
                behavior:'auto'
              });
            }, options);
          });

          document.addEventListener('shopify:block:select', event => {
            if (!this.tabs.some(
              tab => tab.dataset.tab === event.detail.blockId
            )) return;
            this.activate(event.detail.blockId);
          }, options);

          this.saved = new Set();

          try {
            const stored = JSON.parse(
              localStorage.getItem(this.storageKey) || '[]'
            );
            if (Array.isArray(stored)) {
              this.saved = new Set(stored.filter(
                value => typeof value === 'string'
              ));
            }
          } catch (error) {
            this.saved = new Set();
          }

          this.querySelectorAll('[data-save]').forEach(button => {
            button.hidden = false;
            button.addEventListener('click', () => {
              const handle = button.dataset.save;
              const next = new Set(this.saved);

              if (next.has(handle)) next.delete(handle);
              else next.add(handle);

              try {
                localStorage.setItem(
                  this.storageKey,
                  JSON.stringify([...next])
                );
                this.saved = next;
                this.paintSaved();
                this.querySelector('[data-status]').textContent =
                  next.has(handle)
                    ? 'Product saved on this browser.'
                    : 'Product removed from saved items.';
              } catch (error) {
                this.querySelector('[data-status]').textContent =
                  'Your browser could not save this product.';
              }
            }, options);
          });

          this.paintSaved();
        }

        activate(id) {
          this.tabs.forEach(tab => {
            const active = tab.dataset.tab === id;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });

          this.panels.forEach(panel => {
            panel.hidden = panel.dataset.panel !== id;
          });
        }

        paintSaved() {
          this.querySelectorAll('[data-save]').forEach(button => {
            button.setAttribute(
              'aria-pressed',
              String(this.saved.has(button.dataset.save))
            );
          });
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khascart-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('khascart-featured-products')) {
    customElements.define('khascart-featured-products', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.key = 'khascart-saved-products-v1';
        this.buttons = [...this.querySelectorAll('[data-save]')];

        this.refreshSaved();

        this.buttons.forEach(button => {
          button.hidden = false;

          button.addEventListener('click', () => {
            this.refreshSaved();

            const handle = button.dataset.save;
            const next = new Set(this.saved);

            if (next.has(handle)) next.delete(handle);
            else next.add(handle);

            try {
              localStorage.setItem(this.key, JSON.stringify([...next]));
              this.refreshSaved();

              document.dispatchEvent(new CustomEvent('khascart:saved-change'));

              this.querySelector('[data-status]').textContent =
                next.has(handle)
                  ? 'Product saved on this browser.'
                  : 'Product removed from saved items.';
            } catch (error) {
              this.querySelector('[data-status]').textContent =
                'Your browser could not save this product.';
            }
          }, options);
        });

        window.addEventListener('storage', event => {
          if (event.key === this.key || event.key === null) {
            this.refreshSaved();
          }
        }, options);

        window.addEventListener('focus', () => this.refreshSaved(), options);

        this.addEventListener('pointerenter', () => {
          this.refreshSaved();
        }, options);

        document.addEventListener('khascart:saved-change', () => {
          this.refreshSaved();
        }, options);
      }

      refreshSaved() {
        this.saved = new Set();

        try {
          const data = JSON.parse(localStorage.getItem(this.key) || '[]');
          if (Array.isArray(data)) {
            this.saved = new Set(data.filter(value => typeof value === 'string'));
          }
        } catch (error) {
          this.saved = new Set();
        }

        this.buttons.forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(this.saved.has(button.dataset.save))
          );
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khascart-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('khascart-header')) {
    customElements.define('khascart-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dropdown = this.querySelector('.kh-categories');

        document.addEventListener('click', (event) => {
          if (this.dropdown && !this.dropdown.contains(event.target)) {
            this.dropdown.open = false;
          }
        }, options);

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.dropdown?.open) {
            this.dropdown.open = false;
            this.dropdown.querySelector('summary').focus();
          }
        }, options);

        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.isConnected) return;
            if (this.dropdown &&
                !this.dropdown.contains(document.activeElement)) {
              this.dropdown.open = false;
            }
          });
        }, options);

        const refresh = () => this.refreshCart();
        window.addEventListener('pageshow', refresh, options);
        window.addEventListener('focus', refresh, options);
        document.addEventListener('cart:updated', refresh, options);
        document.addEventListener('cart:refresh', refresh, options);

        const cartLink = this.querySelector('[data-kh-cart]');
        cartLink?.addEventListener('pointerenter', refresh, options);
        cartLink?.addEventListener('focus', refresh, options);

        if (typeof subscribe === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
        }
      }

      async refreshCart() {
        if (this.pending || !this.isConnected) return;
        this.pending = true;
        try {
          const response = await fetch(this.dataset.cartUrl, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            signal: this.controller.signal
          });
          if (!response.ok) return;
          const cart = await response.json();
          const badge = this.querySelector('[data-kh-count]');
          if (badge) badge.textContent = cart.item_count;
        } catch (error) {
          // Keep the existing count if the request is interrupted.
        } finally {
          this.pending = false;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khascart-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('khascart-image-slider')) {
    customElements.define(
      'khascart-image-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };

          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.index = 0;
          this.busy = false;
          this.hovering = false;
          this.pointer = null;
          this.animations = [];
          this.delay = Number(this.dataset.delay) || 5000;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.paused = this.dataset.autoplay !== 'true';

          this.paint();

          if (this.slides.length < 2) return;

          this.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            this.hovering = true;
            this.stop();
          }, options);

          this.addEventListener('pointerleave', () => {
            this.hovering = false;
            this.start();
          }, options);

          this.addEventListener('focusin', () => {
            this.stop();
          }, options);

          this.addEventListener('focusout', () => {
            requestAnimationFrame(() => this.start());
          }, options);

          this.addEventListener('keydown', event => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.go(-1);
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.go(1);
            }

            if (event.code === 'Space') {
              event.preventDefault();
              this.paused = !this.paused;
              this.start();
            }
          }, options);

          this.addEventListener('pointerdown', event => {
            if (!event.isPrimary || event.button !== 0) return;

            this.pointer = {
              id: event.pointerId,
              x: event.clientX,
              y: event.clientY
            };

            this.stop();
          }, options);

          window.addEventListener('pointerup', event => {
            if (!this.pointer ||
                event.pointerId !== this.pointer.id) return;

            const dx = event.clientX - this.pointer.x;
            const dy = event.clientY - this.pointer.y;
            this.pointer = null;

            if (Math.abs(dx) > 45 &&
                Math.abs(dx) > Math.abs(dy)) {
              this.go(dx < 0 ? 1 : -1);
            } else {
              this.start();
            }
          }, options);

          window.addEventListener('pointercancel', event => {
            if (!this.pointer ||
                event.pointerId !== this.pointer.id) return;

            this.pointer = null;
            this.start();
          }, options);

          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              this.pointer = null;
              this.stop();
            } else {
              this.start();
            }
          }, options);

          this.motion.addEventListener('change', () => {
            this.start();
          }, options);

          this.start();
        }

        paint() {
          const current = this.slides[this.index];
          if (!current) return;

          this.style.setProperty(
            '--desktop-ratio',
            current.dataset.desktopRatio
          );

          this.style.setProperty(
            '--mobile-ratio',
            current.dataset.mobileRatio
          );

          this.slides.forEach((slide, index) => {
            const active = index === this.index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.inert = !active;
          });
        }

        async go(direction) {
          if (this.busy || this.slides.length < 2) return;

          this.stop();
          this.busy = true;

          const controller = this.controller;
          const previous = this.slides[this.index];

          this.index = (
            this.index + direction + this.slides.length
          ) % this.slides.length;

          const next = this.slides[this.index];

          previous.classList.add('is-moving');
          this.paint();

          if (!this.motion.matches) {
            const timing = {
              duration:700,
              easing:'cubic-bezier(.22,.68,.15,1)'
            };

            this.animations = [
              previous.animate([
                { transform:'translateX(0)' },
                { transform:`translateX(${-direction * 100}%)` }
              ], timing),

              next.animate([
                { transform:`translateX(${direction * 100}%)` },
                { transform:'translateX(0)' }
              ], timing)
            ];

            try {
              await Promise.all(
                this.animations.map(animation => animation.finished)
              );
            } catch (error) {
              // Section reloads can cancel active animations.
            }
          }

          previous.classList.remove('is-moving');

          if (controller.signal.aborted) return;

          this.animations = [];
          this.busy = false;
          this.start();
        }

        stop() {
          clearTimeout(this.timer);
        }

        start() {
          this.stop();

          if (
            !this.isConnected ||
            this.slides.length < 2 ||
            this.paused ||
            this.motion.matches ||
            this.busy ||
            this.hovering ||
            this.pointer ||
            document.hidden ||
            this.contains(document.activeElement)
          ) return;

          this.timer = setTimeout(() => this.go(1), this.delay);
        }

        disconnectedCallback() {
          this.stop();
          this.controller?.abort();
          this.animations?.forEach(animation => animation.cancel());
          this.querySelectorAll('.is-moving').forEach(slide => {
            slide.classList.remove('is-moving');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
